module.exports = __webpack_public_path__ + "static/finding-my-leadership-voice-social-banners-1200x630-534a0b67ee37848f5d26b47d17cbc145.jpg";